"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Image = _interopRequireDefault(require("../Image"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const TestimonialContainer = /*#__PURE__*/_styledComponents.default.figure.withConfig({
  displayName: "Testimonial__TestimonialContainer",
  componentId: "components-web__sc-1az53gr-0"
})(_ref => {
  let {
    testimonialContainerGap
  } = _ref;
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: testimonialContainerGap,
    margin: 0
  };
});
const QuoteContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Testimonial__QuoteContainer",
  componentId: "components-web__sc-1az53gr-1"
})(_ref2 => {
  let {
    quoteContainerGap
  } = _ref2;
  return {
    display: 'flex',
    alignItems: 'center',
    gap: quoteContainerGap
  };
});
const Divider = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Testimonial__Divider",
  componentId: "components-web__sc-1az53gr-2"
})(_ref3 => {
  let {
    dividerBorder,
    dividerBackgroundColor
  } = _ref3;
  return {
    height: dividerBorder,
    background: dividerBackgroundColor,
    width: '100%'
  };
});
const BlockQuote = /*#__PURE__*/_styledComponents.default.blockquote.withConfig({
  displayName: "Testimonial__BlockQuote",
  componentId: "components-web__sc-1az53gr-3"
})({
  margin: 0
});
const AuthorInfoContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Testimonial__AuthorInfoContainer",
  componentId: "components-web__sc-1az53gr-4"
})({
  display: 'flex',
  flexDirection: 'column'
});
const Figcaption = /*#__PURE__*/_styledComponents.default.figcaption.withConfig({
  displayName: "Testimonial__Figcaption",
  componentId: "components-web__sc-1az53gr-5"
})(_ref4 => {
  let {
    figcaptionGap
  } = _ref4;
  return {
    display: 'flex',
    alignItems: 'center',
    gap: figcaptionGap
  };
});
const Testimonial = /*#__PURE__*/_react.default.forwardRef((_ref5, ref) => {
  let {
    showDivider,
    testimonial,
    title,
    imageSrc,
    image = imageSrc,
    additionalInfo,
    testimonialStyle = 'large',
    tokens,
    copy = 'en',
    variant = {},
    ...rest
  } = _ref5;
  const viewport = (0, _componentsBase.useViewport)();
  const {
    testimonialContainerGap,
    quoteContainerGap,
    dividerBorder,
    dividerBackgroundColor,
    figcaptionGap,
    textColor,
    icon,
    iconFr,
    iconColor,
    imageSize,
    testimonialFontSizeLarge,
    testimonialLineHeightLarge,
    testimonialFontWeightLarge,
    testimonialFontSizeHeading,
    testimonialLineHeightHeading,
    testimonialFontNameHeading,
    testimonialFontWeightHeading,
    authorFontSize,
    authorLineHeight,
    authorFontName,
    authorFontWeight,
    additionalFontSize,
    additionalLineHeight,
    additionalFontName,
    additionalFontWeight
  } = (0, _componentsBase.useThemeTokens)('Testimonial', tokens, variant, {
    viewport
  });
  const getQuoteTestimonial = open => {
    let quote = '';
    if (copy === 'en') quote = open ? '\u201C' : '\u201D';else quote = open ? '\u00AB ' : ' \u00BB';
    return quote;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(TestimonialContainer, {
    testimonialContainerGap: testimonialContainerGap,
    ref: ref,
    ...selectProps(rest),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(QuoteContainer, {
      quoteContainerGap: quoteContainerGap,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Icon, {
        tokens: {
          color: iconColor
        },
        variant: {
          size: 'micro'
        },
        icon: copy === 'en' ? icon : iconFr
      }), showDivider && /*#__PURE__*/(0, _jsxRuntime.jsx)(Divider, {
        dividerBackgroundColor: dividerBackgroundColor,
        dividerBorder: dividerBorder,
        role: "separator"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(BlockQuote, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
        variant: {
          size: testimonialStyle === 'large' ? 'large' : 'h3'
        },
        tokens: {
          color: textColor,
          fontSize: testimonialStyle === 'heading' ? testimonialFontSizeHeading : testimonialFontSizeLarge,
          lineHeight: testimonialStyle === 'heading' ? testimonialLineHeightHeading : testimonialLineHeightLarge,
          fontName: testimonialFontNameHeading,
          fontWeight: testimonialStyle === 'heading' ? testimonialFontWeightHeading : testimonialFontWeightLarge
        },
        children: `${getQuoteTestimonial(true)}${testimonial}${getQuoteTestimonial()}`
      })
    }), (image || title || additionalInfo) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(Figcaption, {
      figcaptionGap: figcaptionGap,
      children: [image && (typeof image === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.default, {
        rounded: "circle",
        src: image,
        alt: title,
        width: imageSize,
        height: imageSize
      }) : image), (title || additionalInfo) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(AuthorInfoContainer, {
        children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
          variant: {
            size: 'small'
          },
          tokens: {
            color: textColor,
            fontSize: authorFontSize,
            lineHeight: authorLineHeight,
            fontName: authorFontName,
            fontWeight: authorFontWeight
          },
          children: title
        }), additionalInfo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
          variant: {
            size: 'small'
          },
          tokens: {
            color: textColor,
            fontSize: additionalFontSize,
            lineHeight: additionalLineHeight,
            fontName: additionalFontName,
            fontWeight: additionalFontWeight
          },
          children: additionalInfo
        })]
      })]
    }), showDivider && /*#__PURE__*/(0, _jsxRuntime.jsx)(Divider, {
      dividerBackgroundColor: dividerBackgroundColor,
      dividerBorder: dividerBorder,
      role: "separator"
    })]
  });
});
Testimonial.displayName = 'Testimonial';
Testimonial.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _componentsBase.getTokensPropType)('Testimonial'),
  /**
   * Testimonial content
   */
  testimonial: _propTypes.default.string.isRequired,
  /**
   * Testimonial author or source
   */
  title: _propTypes.default.string,
  /**
   * Additional information on the author or source
   */
  additionalInfo: _propTypes.default.string,
  /**
   * Testimonial style
   */
  testimonialStyle: _propTypes.default.oneOf(['large', 'heading']),
  /**
   * Whether to show or not dividers at the top and the bottom of the testimonial
  showDivider: PropTypes.bool,
  /**
   * The src attribute for the Image component or custom JSX content to render instead
   */
  image: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /**
   * The src attribute for the `Image` component to be displayed on the testimonial
   * @deprecated please use the `image` prop instead
   */
  imageSrc: _propTypes.default.string
};
var _default = exports.default = Testimonial;